(() => {
    'use strict';

    angular
        .module('cog.shared')
        .service('betModelTransformer', betModelTransformer);

    /* @ngInject */
    function betModelTransformer($http, $state, $q, $window, lineFormater: ILineFormater, customerGameSelection, accountService, BET_TYPES, CogApiServiceProvider) {
        var service: IBetTranformer = {
            getLineFormat: (line, useSpan: boolean) => {
                // div is used for bet modal using css to make odd align to middle
                useSpan = (angular.isUndefined(useSpan) || useSpan) ? true : false;
                var oddTag = (useSpan) ? "span" : "div";
                var format = "";
                var formated = lineFormater.format(line.Id);
                if (formated.Points.length > 0) {
                    if (accountService.getBetSelectionType() != BET_TYPES.T.type) {
                        if (formated.Points != "pk" && formated.Points != "+&frac12;" && formated.Points != "-&frac12;")
                            format = formated.Points + "&nbsp;<" + oddTag + " class='txt2'>" + formated.Odds + "</" + oddTag + ">";
                        else
                            format = "<span class='txt2'>" + formated.Points + "</span> &nbsp;" + formated.Odds;
                    }
                    else
                        format = formated.Points;
                } else
                    format = formated.Odds;
                return format;
            },
            transform: (data, replace) => {
                var arr: BetCardSimple = { Details: [], TicketNumber: 0, BetErrs: [], RoundRobinOptions: [], OpenSpots: 0 };
                var isStraight = (accountService.getBetSelectionType() == BET_TYPES.S.type || accountService.getBetSelectionType() == BET_TYPES.E.type) ? true : false;
                var isIfBet = (accountService.getBetSelectionType() == BET_TYPES.I.type) ? true : false;
                var isTeaser = (accountService.getBetSelectionType() == BET_TYPES.T.type) ? true : false;
                var isPropfecta = (accountService.getBetSelectionType() == BET_TYPES.B.type) ? true : false;
                var is_bm: boolean = CogApiServiceProvider.is_BM();
                $window._.map(data.Bets, (header: BetHeader) => {
                    /*if (header.BetItems.length == 0) {
                        var itm = <BetDetailSimple>{};
                        itm.Error.Id = "1";
                        itm.Error.Description = header.Errors.Items[0].Description;
                        arr.Details.push(itm);
                    } else {*/
                    if (header.BetItems.length > 0) {
                        $window._.map(header.BetItems, (item: BetDetail) => {
                            var itm = <BetDetailSimple>item;
                            itm.Risk = header.Risk;
                            itm.Win = header.Win;
                            itm.PitcherSelection = (item.PitcherSelection != "(Fixed)/(Fixed)") ? itm.PitcherSelection : '';
                            itm.Error = { Id: "0", Description: "", PreviousId: "", CancelOnError: true, AutoAccepted: false };
                            itm.BetAmount = header.Risk;
                            // set bet amount for straight
                            var betItem = $window._.find(customerGameSelection.gameSelections.Items, function (o) {
                                var arrKey = o.Key.split('_');
                                var tKey = o.Key;
                                if (arrKey.length > 7) {
                                    arrKey.splice(-2);
                                    tKey = arrKey.join('_');
                                }
                                return tKey == itm.Id;
                            });
                            if ((isStraight || isIfBet) && betItem != null && betItem != "undefined") {
                                itm.BetAmount = betItem.Amount;
                            }
                            itm.lines = (betItem != null) ? betItem.lines : [];
                            itm.lineSelected = null;
                            if (itm.lines.length > 0) {
                                var selectedLine = $window._.find(itm.lines, function (line:ILineObj) {
                                    return line.Id == itm.Id;
                                });
                                itm.lineSelected = selectedLine;
                            }

                            /*if (header.Errors.Bet.length > 0) {
                                itm.Error.Id = "1";
                                itm.Error.Description = header.Errors.Bet[0].Description;
                            } else*/
                            if (header.Errors.Items.length > 0) {
                                var errItem = $window._.find(header.Errors.Items, function (o) { return o.Id == itm.Id; });
                                if (errItem != null && errItem != "undefined") {
                                    itm.Error.Id = "2";
                                    itm.Error.Description = errItem.Description;
                                    itm.Error.CancelOnError = errItem.ErrorType;
                                }
                            }

                            if (header.Errors.LineChanges.length > 0) {
                                var errItem = $window._.find(header.Errors.LineChanges, function (o) { return o.Id == itm.Id; });
                                if (errItem != null && errItem != "undefined") {
                                    itm.Error.AutoAccepted = errItem.AutoAccepted;
                                    itm.Error.PreviousId = errItem.PreviousId;
                                    itm.Error.Id = "3";
                                    if (errItem.AutoAccepted) {
                                        itm.Error.Description = 'Line has changed in your favor';
                                        if (isStraight || (!isStraight && replace))
                                            customerGameSelection.gameSelections.Swap(errItem.PreviousId, itm.Id, true);
                                    }
                                    else                                        
                                        itm.Error.Description = 'Line has changed, ACCEPT or DELETE wager to continue.';// errItem.Description;
                                }
                            }

                            var newId = item.Id.split('_');
                            if (newId[2] != itm.Points.toString() || newId[3] != itm.Odds.toString()) {
                                newId[2] = itm.Points.toString();
                                newId[3] = itm.Odds.toString();
                            }

                            itm.LineDesc = "";
                            var line: FormatedLine = lineFormater.format(newId.join('_'));
                            if (line.Points.length > 0) {
                                if (!isTeaser)
                                    itm.LineDesc = line.Points + " <span class='txt2'>" + line.Odds + "</span>";
                                else
                                    itm.LineDesc = line.Points;
                            }
                            else
                                itm.LineDesc = line.Odds;

                            if(!itm.Mascot && itm.Mascot.length == 0)
                                itm.Mascot = itm.Team;

                            var data = lineFormater.data(item.Id);
                            if (data.IsTeamTotal) {
                                if (is_bm)
                                    itm.Team += " Team Total";
                                else {
                                    itm.Team += "<span class='tmTotal'>Team Total</span>";
                                    itm.Mascot += "<br><span class='tmTotal'> Team Total</span>";
                                }
                            }
                            if (data.IsTotal && !is_bm) {
                                var tempM = itm.Mascot.split("/");
                                if (tempM.length > 1) 
                                    itm.Mascot = tempM[0] + "<br>" + tempM[1];
                            }
                            // add period description
                            if (is_bm)
                                itm.LineDesc += (itm.PeriodDescription.toLowerCase() != 'game') ? '<span class="perioddesc">' + itm.PeriodDescription + '</span>' : '';
                            else {
                                if(itm.Team.toLowerCase().indexOf("win game") == -1 && itm.Team.toLowerCase().indexOf("wins game") == -1) {
                                    itm.Team += (itm.PeriodDescription.toLowerCase() != 'game') ? '<br><span class="perioddesc">' + itm.PeriodDescription + '</span>' : '';
                                    if (itm.Mascot.length > 0)
                                        itm.Mascot += (itm.PeriodDescription.toLowerCase() != 'game') ? '<br><span class="perioddesc">' + itm.PeriodDescription + '</span>' : '';
                                }
                            }

                            // rewrite for propfecta
                            if (isPropfecta && LineFormatter!=null) {
                                // for line update use newId.join('_') instead of item.Id
                                itm.LineDesc = LineFormatter.getParlayPropLineFormat(newId.join('_'));
                            }

                            var idxAlt = itm.Team.indexOf(" Alt Line");
                            if (idxAlt > 0)
                                itm.Team = itm.Team.replace(" Alt Line", " ");

                            arr.Details.push(itm);
                        });
                    }
                    // check bet errors, not associated to a specific item but rather for the whole bet so we separate it
                    if (header.Errors.Bet.length > 0) {
                        arr.BetErrs = header.Errors.Bet;
                    }

                    angular.forEach(header.RoundRobinOptions, function (rr) {
                        var itm = <RoundRobin>rr;
                        arr.RoundRobinOptions.push(itm);
                    });

                    if (header.BetType == BET_TYPES.P.type || header.BetType == BET_TYPES.T.type) {
                        if (header.OpenSpots != null && header.OpenSpots > 0) {
                            arr.OpenSpots = header.OpenSpots;
                        }
                    }
                    /*
                    // test bet errs
                    arr.BetErrs = [
                        { Description: 'test err bet issue 1' },
                        { Description: 'test err bet issue 1' },
                        { Description: 'test err bet issue 1' }
                    ];*/
                });
                arr.TicketNumber = data.TicketNumber;
                return arr;
            }
        };
        return service;
    }
})();